document.addEventListener("DOMContentLoaded", function () {
  var location = window.location.href;
  var hash = window.location.hash;
  // adding inner content of sharing
  function innerContent(_imageName) {
    if (location.indexOf(hash) > -1) {
      location = location.replace(hash, "");
    }
    // All SVG social sharing images
    var image = {
      shareIcon:
        '<svg width="13px" height="16px" viewBox="0 0 13 16" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">' +
        '<g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">' +
        '<g id="ShareThisImage_button" transform="translate(-961.000000, -370.000000)" fill="#009CFC" fill-rule="nonzero" stroke="#009CFC" stroke-width="0.3">' +
        '<g id="Share-Icon" transform="translate(962.000000, 371.000000)">' +
        '<path d="M10.5416622,5 L9.16667554,5 L9.16667554,5.81819046 L10.0833511,5.81819046 L10.0833511,13.1818333 L0.916675537,13.1818333 L0.916675537,5.81819046 L1.83335107,5.81819046 L1.83335107,5 L0.458337769,5 C0.20499192,5 0,5.18296816 0,5.40909523 L0,13.5909048 C0,13.8170318 0.20499192,14 0.458337769,14 L10.5416622,14 C10.7950081,14 11,13.8170318 11,13.5909048 L11,5.40909523 C11,5.18296816 10.7950081,5 10.5416622,5 Z" id="Path"></path>' +
        '<polygon id="Path" points="5.05270357 1.48871169 5.05270357 7 5.94729643 7 5.94729643 1.48871169 7.86750524 3.15819761 8.5 2.60828809 5.5 0 2.5 2.60828809 3.13249476 3.15819761"></polygon>' +
        "</g>" +
        "</g>" +
        "</g>" +
        "</svg>",
      facebook:
        '<svg width="7px" height="13px" viewBox="0 0 7 13" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">' +
        '<g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">' +
        '<g id="share-this-image_onclick" transform="translate(-1030.000000, -245.000000)" fill="#333333" fill-rule="nonzero">' +
        '<g id="Group-2" transform="translate(1005.000000, 201.000000)">' +
        '<path d="M31.7364005,44.0027049 L30.0574188,44 C28.1711405,44 26.9521445,45.2557348 26.9521445,47.1993175 L26.9521445,48.6744172 L25.2640035,48.6744172 C25.1181281,48.6744172 25,48.7931608 25,48.9396294 L25,51.0768807 C25,51.2233493 25.1182628,51.3419577 25.2640035,51.3419577 L26.9521445,51.3419577 L26.9521445,56.734923 C26.9521445,56.8813916 27.0702727,57 27.2161481,57 L29.4186919,57 C29.5645673,57 29.6826955,56.8812563 29.6826955,56.734923 L29.6826955,51.3419577 L31.656526,51.3419577 C31.8024014,51.3419577 31.9205295,51.2233493 31.9205295,51.0768807 L31.9213377,48.9396294 C31.9213377,48.8693029 31.8934557,48.8019517 31.8440224,48.7521821 C31.7945891,48.7024125 31.7272412,48.6744172 31.6571995,48.6744172 L29.6826955,48.6744172 L29.6826955,47.4239568 C29.6826955,46.8229352 29.8253382,46.5178261 30.6050915,46.5178261 L31.7361312,46.5174204 C31.8818719,46.5174204 32,46.3986767 32,46.2523434 L32,44.2677819 C32,44.1215838 31.8820066,44.0029754 31.7364005,44.0027049 Z" id="Path"></path>' +
        "</g>" +
        "</g>" +
        "</g>" +
        "</svg>",
      linkedIn:
        '<svg width="14px" height="13px" viewBox="0 0 14 13" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">' +
        '<g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">' +
        '<g id="share-this-image_onclick" transform="translate(-1029.000000, -216.000000)" fill="#333333" fill-rule="nonzero">' +
        '<g id="Group-2" transform="translate(1005.000000, 201.000000)">' +
        '<g id="Group-3" transform="translate(24.000000, 15.000000)">' +
        '<rect id="Rectangle" x="0" y="4" width="3" height="9"></rect>' +
        '<path d="M13.0686313,5.00750955 C12.4478757,4.33587797 11.626851,4 10.6060591,4 C10.2299548,4 9.88807029,4.04585524 9.58056242,4.13762789 C9.27314865,4.22933837 9.01350461,4.35801284 8.80150485,4.52371346 C8.58963055,4.68941409 8.42088388,4.84323899 8.29560987,4.98518815 C8.1764835,5.1200181 8.05999184,5.27707618 7.94632309,5.4547458 L7.94632309,4.20400141 L5,4.20400141 L5.00903328,4.63009762 C5.01508683,4.91421357 5.01806656,5.78990874 5.01806656,7.25730748 C5.01806656,8.72483057 5.0121071,10.6389992 5.00012546,13 L7.94632309,13 L7.94632309,8.09156195 C7.94632309,7.78985002 7.97897463,7.55025251 8.04477955,7.37258288 C8.17024176,7.07065334 8.35959559,6.81787439 8.61346837,6.6138108 C8.86730978,6.40949851 9.18212582,6.30743563 9.55835561,6.30743563 C10.0716215,6.30743563 10.4493568,6.48345757 10.6911852,6.83553254 C10.9329195,7.18757643 11.0538024,7.67429481 11.0538024,8.29562553 L11.0538024,12.9997202 L14,12.9997202 L14,7.95856621 C13.9997804,6.66255725 13.6895751,5.67892352 13.0686313,5.00750955 Z" id="Path"></path>' +
        '<path d="M1.50801725,0 C1.05944296,0 0.695977379,0.141919295 0.417535311,0.42548136 C0.139121641,0.709104875 0,1.06717534 0,1.50003073 C0,1.92683327 0.135117528,2.28367472 0.405380981,2.57015567 C0.67555924,2.85666735 1.0323513,3 1.47555837,3 L1.49177361,3 C1.94585711,3 2.31210569,2.85679025 2.59043416,2.57015567 C2.86876264,2.28367472 3.00521487,1.92695617 2.99984766,1.50003073 C2.99445204,1.06720606 2.85652312,0.709104875 2.58634486,0.42548136 C2.316195,0.141796395 1.95661994,0 1.50801725,0 Z" id="Path"></path>' +
        "</g>" +
        "</g>" +
        "</g>" +
        "</g>" +
        "</svg>",
      twitter:
        '<svg width="16px" height="13px" viewBox="0 0 16 13" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">' +
        "<defs>" +
        '<path d="M37,75.539 C36.405,75.8 35.771,75.973 35.11,76.057 C35.79,75.651 36.309,75.013 36.553,74.244 C35.919,74.622 35.219,74.889 34.473,75.038 C33.871,74.397 33.013,74 32.077,74 C30.261,74 28.799,75.474 28.799,77.281 C28.799,77.541 28.821,77.791 28.875,78.029 C26.148,77.896 23.735,76.589 22.114,74.598 C21.831,75.089 21.665,75.651 21.665,76.256 C21.665,77.392 22.25,78.399 23.122,78.982 C22.595,78.972 22.078,78.819 21.64,78.578 C21.64,78.588 21.64,78.601 21.64,78.614 C21.64,80.208 22.777,81.532 24.268,81.837 C24.001,81.91 23.71,81.945 23.408,81.945 C23.198,81.945 22.986,81.933 22.787,81.889 C23.212,83.188 24.418,84.143 25.852,84.174 C24.736,85.047 23.319,85.573 21.785,85.573 C21.516,85.573 21.258,85.561 21,85.528 C22.453,86.465 24.175,87 26.032,87 C32.068,87 35.368,82 35.368,77.666 C35.368,77.521 35.363,77.381 35.356,77.242 C36.007,76.78 36.554,76.203 37,75.539 Z" id="path-1"></path>' +
        '<filter x="-12.5%" y="-15.4%" width="125.0%" height="130.8%" filterUnits="objectBoundingBox" id="filter-2">' +
        '<feGaussianBlur stdDeviation="1.5" in="SourceAlpha" result="shadowBlurInner1"></feGaussianBlur>' +
        '<feOffset dx="0" dy="1" in="shadowBlurInner1" result="shadowOffsetInner1"></feOffset>' +
        '<feComposite in="shadowOffsetInner1" in2="SourceAlpha" operator="arithmetic" k2="-1" k3="1" result="shadowInnerInner1"></feComposite>' +
        '<feColorMatrix values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0" type="matrix" in="shadowInnerInner1"></feColorMatrix>' +
        "</filter>" +
        "</defs>" +
        '<g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">' +
        '<g id="share-this-image_onclick" transform="translate(-1026.000000, -275.000000)" fill-rule="nonzero">' +
        '<g id="Group-2" transform="translate(1005.000000, 201.000000)">' +
        '<g id="twitter">' +
        '<use fill="#333333" xlink:href="#path-1"></use>' +
        '<use fill="black" fill-opacity="1" filter="url(#filter-2)" xlink:href="#path-1"></use>' +
        "</g>" +
        "</g>" +
        "</g>" +
        "</g>" +
        "</svg>",
      whatsapp:
        '<svg width="15px" height="15px" viewBox="0 0 15 15" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">' +
        '<g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">' +
        '<g id="share-this-image_onclick" transform="translate(-1027.000000, -304.000000)" fill-rule="nonzero">' +
        '<g id="Group-2" transform="translate(1005.000000, 201.000000)">' +
        '<g id="Group" transform="translate(22.000000, 103.000000)">' +
        '<path d="M7.501875,9.76996262e-15 L7.498125,9.76996262e-15 C3.3628125,9.76996262e-15 9.76996262e-15,3.36375 9.76996262e-15,7.5 C9.76996262e-15,9.140625 0.52875,10.66125 1.4278125,11.8959375 L0.493125,14.6821875 L3.3759375,13.760625 C4.561875,14.54625 5.9765625,15 7.501875,15 C11.6371875,15 15,11.6353125 15,7.5 C15,3.3646875 11.6371875,9.76996262e-15 7.501875,9.76996262e-15 Z" id="Path" fill="#333333"></path>' +
        '<path d="M11.8659375,10.5909375 C11.685,11.101875 10.966875,11.525625 10.3940625,11.649375 C10.0021875,11.7328125 9.4903125,11.799375 7.7671875,11.085 C5.563125,10.171875 4.14375,7.9321875 4.033125,7.786875 C3.9271875,7.6415625 3.1425,6.6009375 3.1425,5.5246875 C3.1425,4.4484375 3.6890625,3.924375 3.909375,3.699375 C4.0903125,3.5146875 4.389375,3.4303125 4.67625,3.4303125 C4.7690625,3.4303125 4.8525,3.435 4.9275,3.43875 C5.1478125,3.448125 5.2584375,3.46125 5.40375,3.8090625 C5.5846875,4.245 6.0253125,5.32125 6.0778125,5.431875 C6.13125,5.5425 6.1846875,5.6925 6.1096875,5.8378125 C6.039375,5.9878125 5.9775,6.054375 5.866875,6.181875 C5.75625,6.309375 5.65125,6.406875 5.540625,6.54375 C5.439375,6.6628125 5.325,6.7903125 5.4525,7.010625 C5.58,7.22625 6.020625,7.9453125 6.669375,8.5228125 C7.5065625,9.268125 8.1853125,9.50625 8.428125,9.6075 C8.6090625,9.6825 8.8246875,9.6646875 8.956875,9.5240625 C9.1246875,9.343125 9.331875,9.043125 9.5428125,8.7478125 C9.6928125,8.5359375 9.8821875,8.5096875 10.0809375,8.5846875 C10.2834375,8.655 11.355,9.1846875 11.5753125,9.294375 C11.795625,9.405 11.9409375,9.4575 11.994375,9.5503125 C12.046875,9.643125 12.046875,10.0790625 11.8659375,10.5909375 Z" id="Path" fill="#FFFFFF"></path>' +
        "</g>" +
        "</g>" +
        "</g>" +
        "</g>" +
        "</svg>",
      mail:
        '<svg width="15px" height="10px" viewBox="0 0 15 10" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">' +
        '<g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">' +
        '<g id="share-this-image_onclick" transform="translate(-1027.000000, -336.000000)" fill="#333333" fill-rule="nonzero">' +
        '<g id="Group-2" transform="translate(1005.000000, 201.000000)">' +
        '<g id="Group-5-Copy" transform="translate(22.003024, 135.625000)">' +
        '<path d="M7.78638908,6.64627919 C7.68576589,6.73979886 7.54971619,6.79224758 7.40771246,6.79224758 C7.26570873,6.79224758 7.12965903,6.73979886 7.02903584,6.64627919 L0.0523955067,0.142360803 C0.0315563847,0.222560163 9.05941988e-14,0.299429447 9.05941988e-14,0.386011455 L9.05941988e-14,8.37625433 C9.05941988e-14,8.92793713 0.479299806,9.375 1.07142857,9.375 L13.9282737,9.375 C14.5195094,9.375 15,8.92821463 15,8.37625433 L15,0.386011455 C15,0.249200781 14.9696344,0.117940236 14.9157504,0 L7.78638908,6.64627919 Z" id="Path"></path>' +
        '<path d="M7.3813161,5.99542966 L13.6912571,0.0195929074 C13.6552634,0.0161037595 13.6255049,0 13.5889444,0 L1.34912137,0 C1.26154628,0 1.18162338,0.0276447871 1.1,0.0469692985 L7.3813161,5.99542966 Z" id="Path"></path>' +
        "</g>" +
        "</g>" +
        "</g>" +
        "</g>" +
        "</svg>",
    };
    // All  social sharing Url patterns
    var url = {
      facebook:
        'data-href="https://www.facebook.com/sharer/sharer.php?u=' +
        encodeURI(location) +
        "%23" +
        _imageName +
        '"  onclick="openWindowToShare(this,\'facebook\')" data-clicked="0"',
      twitter:
        'data-href="https://www.twitter.com/share?url=' +
        encodeURI(location) +
        "%23" +
        _imageName +
        '"  onclick="openWindowToShare(this,\'twitter\')" data-clicked="0"',
      whatsapp:
        "data-href='https://web.whatsapp.com/send?text=" +
        document.title +
        " " +
        encodeURI(location) +
        "#" +
        _imageName +
        '\'  onclick="openWindowToShare(this,\'whatsapp\')" data-clicked="0"',
      mail:
        'href="mailto:?subject=' +
        _imageName +
        "&amp;body=" +
        location +
        "#" +
        _imageName +
        '" data-clicked="0" data-platform="mail"',
      linkedIn:
        'data-href="https://www.linkedin.com/shareArticle?url=' +
        encodeURI(location) +
        "#" +
        _imageName +
        '"  onclick="openWindowToShare(this,\'linkedIn\')" data-clicked="0"',
      whatsappMobile:
        'href="whatsapp://send?text=' +
        document.title +
        " " +
        encodeURI(location) +
        "#" +
        _imageName +
        '" data-clicked="0" data-platform="whatsapp"',
    };
    return (
      '<div class="sharable-links__wrapper">' +
      '<span data-clicked="0" class="sharable-links__cta" data-image="' +
      _imageName +
      '">' +
      image["shareIcon"] +
      "Share this Image</span>" +
      '<div class="sharable-links__social-links">' +
      '<ul class="sharable-links_lists">' +
      '<li class="sharable-links_list sharable-links__linkedin"><span ' +
      url["linkedIn"] +
      " >" +
      image["linkedIn"] +
      "on LinkedIn</span></li>" +
      '<li class=" sharable-links_list sharable-links__facebook"><span ' +
      url["facebook"] +
      " >" +
      image["facebook"] +
      "on Facebook</span></li>" +
      '<li class=" sharable-links_list sharable-links__twitter"><span ' +
      url["twitter"] +
      ">" +
      image["twitter"] +
      "on Twitter</span></li>" +
      (isMobOrTab() == false
        ? '<li class="sharable-links_list sharable-links__whatsapp"><span ' +
          url["whatsapp"] +
          ">" +
          image["whatsapp"] +
          "on Whatsapp</span></li>"
        : '<li class="sharable-links_list sharable-links__whatsapp"><a ' +
          url["whatsappMobile"] +
          ">" +
          image["whatsapp"] +
          "on Whatsapp</a></li>") +
      '<li class="sharable-links_list sharable-links__mail"><a ' +
      url["mail"] +
      ">" +
      image["mail"] +
      "on Mail</a></li>" +
      "</ul>" +
      "</div>" +
      "</div>"
    );
  }

  // checking and adding sharing functionality to all images having  infographics-image-share as parent
  var imageSharing = document.querySelectorAll("img.infographics-image-share");
  if (imageSharing) {
    for (var i = 0; i < imageSharing.length; i++) {
      var _this = imageSharing[i];
      if (_this.getAttribute("data-lazy-src")) {
        var url = _this.getAttribute("data-lazy-src");
        if (url && url.indexOf("/") > -1) {
          var _imageName = url.split("/");
          _imageName = _imageName[_imageName.length - 1];
          _imageName = _imageName.replace(/\./g, "-").toLowerCase();
        }
      }
      // Adding class and ID to parent of infographic image
      _this.parentElement.classList.add("infographics-image-share-container");
      var imgParent = _this.parentElement;
      imgParent.innerHTML +=
        '<div class="sharable-links__container">' +
        innerContent(_imageName) +
        "</div>";
      imgParent.setAttribute("id", _imageName);
    }
  }

  //toggle Share functionality on Share image link
  var shareImageClick = document.querySelectorAll(".sharable-links__cta");
  if (shareImageClick) {
    for (var i = 0; i < shareImageClick.length; i++) {
      shareImageClick[i].addEventListener("click", shareImageClickFn);
    }
  }

  function shareImageClickFn() {
    var that = this,
    noOfClicks = Number(that.getAttribute("data-clicked")),
    EventName = "ClickedShareImage";
    that.setAttribute("data-clicked", noOfClicks + 1);
    var shareIcons = that.nextElementSibling;
    if (shareIcons.classList.contains("sharable-links__social-links")) {
      shareIcons.classList.toggle("show");
    }
    var newValue = {
      image: that.getAttribute("data-image"),
      noOfClicks: noOfClicks + 1,
      type: "Share Image Link",
    };
    if (window.hasOwnProperty("WebEventTracker")) {
      WebEventTracker.logEvent("", EventName, newValue);
    }
  }

  //toggle Share functionality on Share image link
  var shareLinkList = document.querySelectorAll(".sharable-links_lists a");
  if (shareLinkList) {
    for (var i = 0; i < shareLinkList.length; i++) {
      shareLinkList[i].addEventListener("click", shareLinkListFn);
    }
  }

  function shareLinkListFn() {
    var that = this,
    noOfClicks = Number(that.getAttribute("data-clicked")),
    EventName = "ClickedShareImage",
    type = that.getAttribute("data-platform");
    that.setAttribute("data-clicked", noOfClicks + 1);

    var newValue = {
      image: that.getAttribute("href"),
      noOfClicks: noOfClicks + 1,
      type: type,
    };
    if (window.hasOwnProperty("WebEventTracker")) {
      WebEventTracker.logEvent("", EventName, newValue);
    }
  }

  // Close Sharing menu on body click
  document.addEventListener(
    "click",
    function (event) {
      if (!event.target.classList.contains("sharable-links__cta")) {
        var socialLinks = document.querySelectorAll(
          ".sharable-links__social-links"
        );

        for (var i = 0; i < socialLinks.length; i++) {
          if (
            socialLinks[i].classList.contains("sharable-links__social-links")
          ) {
            socialLinks[i].classList.remove("show");
          }
        }
      }
    },
    false
  );
});

setTimeout(function () {
  if (window.location.hash && window.location.hash.length) {
    var getElemId = window.location.hash.split('#')[1],
      getMainElem = document.querySelector("[id=" + "\'" + getElemId + "\'" + "]");
    if (getMainElem) {
      bsLib.scrollIt(
        getMainElem.offsetTop - 100,
        300
      );
    }
  }
}, 500);

function openWindowToShare(e, socialNetwork) {
  var noOfclicks = Number(e.getAttribute("data-clicked")),
  EventName = "ClickedShareImage";
  e.setAttribute("data-clicked", noOfclicks + 1);
  e = e.getAttribute("data-href");
  var newValue = {
    image: e,
    noOfClicks: noOfclicks + 1,
    type: socialNetwork,
  };
  if (window.hasOwnProperty("WebEventTracker")) {
    WebEventTracker.logEvent("", EventName, newValue);
  }

  var h = 500,
    w = 700;
  window.open(
    e,
    "",
    "scrollbars=1, height=" +
      Math.min(h, screen.availHeight) +
      ",width=" +
      Math.min(w, screen.availWidth) +
      ",left=" +
      Math.max(0, (screen.availWidth - w) / 2) +
      ",top=" +
      Math.max(0, (screen.availHeight - h) / 2)
  );
}
function isMobOrTab() {
  if (
    navigator.userAgent.match(/Android/i) ||
    navigator.userAgent.match(/webOS/i) ||
    navigator.userAgent.match(/iPhone/i) ||
    navigator.userAgent.match(/iPad/i) ||
    navigator.userAgent.match(/iPod/i) ||
    navigator.userAgent.match(/BlackBerry/i) ||
    navigator.userAgent.match(/Windows Phone/i)
  ) {
    return true;
  } else {
    return false;
  }
}
